/**
 * MusicDownloadedPage - ダウンロード済みのライブラリ（Apple Music 相当）
 *
 * 一覧画面は /music 側と同じものを ?downloaded=1 付きで再利用し、
 * オフライン保存済みの曲だけに絞って表示する。
 */

import { MicVocal, Music } from 'lucide-react'
import { useNavigate } from 'react-router'

import { Header } from '@/components/shared/header'
import { PATHS } from '@/routes/paths'

import { DOWNLOADED_ONLY_QUERY } from './constants'
import { type LibrarySection, LibrarySectionList } from './library-list'

const DOWNLOADED_SECTIONS: LibrarySection[] = [
  { key: 'artists', label: 'アーティスト', Icon: MicVocal, path: `${PATHS.MUSIC.ARTISTS}?${DOWNLOADED_ONLY_QUERY}` },
  { key: 'songs', label: '曲', Icon: Music, path: `${PATHS.MUSIC.SONGS}?${DOWNLOADED_ONLY_QUERY}` },
]

export const MusicDownloadedPage = () => {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Header title="ダウンロード済み" onClose={() => navigate(PATHS.MUSIC.LIBRARY)} />

      <LibrarySectionList sections={DOWNLOADED_SECTIONS} ariaLabel="ダウンロード済み" />
    </div>
  )
}
